// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".theme--light.v-messages{color:rgba(0,0,0,.9)!important;font-weight:500}", ""]);
// Exports
module.exports = exports;
